import { storeWithMiddleware } from '@cmd/ui-utilities';
import { dashboardTimeFieldsReducer, dateRangeReducer, dateRangeUrlUpdater, selectedDashboardReducer, selectedDashboardUrlUpdater, } from './components/LandingPageHeader/LandingPageHeader';
import { sidePanelViewReducer as sidePanelView } from './components/slide-out/SlideOutUtilities';
import { webComponentViewReducer, webComponentViewUrlUpdater, } from './landing-page-content/LandingPageContent';
import { dashboardsIdReceivedReducer } from './state/dashboardIdState';
import { organizationReducer, organizationUrlUpdater } from './state/orgIdState';
const store = storeWithMiddleware({
    dashboardTimeFields: dashboardTimeFieldsReducer,
    dateRange: dateRangeReducer,
    orgId: organizationReducer,
    selectedDashboard: selectedDashboardReducer,
    webComponentView: webComponentViewReducer,
    sidePanelView,
    dashboardsIdReceived: dashboardsIdReceivedReducer,
}, // reducers
[
    organizationUrlUpdater,
    dateRangeUrlUpdater,
    selectedDashboardUrlUpdater,
    webComponentViewUrlUpdater,
]);
export default store;
